import { render, staticRenderFns } from "./ExpandRow.vue?vue&type=template&id=774c3108&"
import script from "./ExpandRow.vue?vue&type=script&lang=js&"
export * from "./ExpandRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports